const [w, d] = [window, document]

const jqReady = () => {

  /*
    オプション選択テーブル
  */
  const $optionTable = $('[data-plugin="optionTable"]')
  const $optionRadio = $(`<input type="radio" name="itemoption" value="">`)

  $optionTable.each((i, v) => {

    const optionNameX = []
    const optionNameY = []

    $( 'thead tr:last-child th', v ).each((i, v) => {
      const name = $(v).text()
      optionNameX.push(name)
    })

    $( 'tbody tr', v ).each((i, v) => {
      const name = $(v).children('th:first-child, td:first-child').text()
      optionNameY.push(name)
    })

    //tdに特定の文字（丸か二重丸か数字）が入っていたらラジオボタンに変換
    $( 'tbody td', v ).each((i, v) => {
      const x = $(v).index()
      const y = $(v).parents('tr').index()
      const value = `${ optionNameX[x] } / ${ optionNameY[y] }`
      if ( /^(○|◯|◎|[\d０-９]+?)$/.test(v.innerText) ) {
        $(v).empty()
        $(v).append($optionRadio.clone(true).val(value) )
      }
    })

    $('input[type=radio]', v).attr('name', 'itemoption' + (i + 1))
  })

  if ( $optionTable.length !== 0 ) {
    $('.btnwrap a.button').on('click', (event) => {
      event.preventDefault()

      let selectedOption = []
      const $inputOption = $("input[name^=itemoption]:checked")
      $inputOption.each((i, v) => {
        selectedOption.push( v.value )
      })

      const $opForm = $(`
      <form id="opForm" method="get" action="/contact/">
        <input name="mode" type="hidden" value="detail">
        <input name="article" type="hidden" value="2">
        <input name="itemoption" type="hidden" value="${selectedOption}">
      </form>
      `)
      $('.entry').append( $opForm )

      d.forms.opForm.submit()
      return false
    })
  }
}

export default function OPTIONTABLE() {
  $( jqReady )
}